module.exports = __webpack_public_path__ + "img/btn_ciudadania_digital_v2.5edfc7a8.png";